<template>
  <LegalDocument
    title="سياسة الخصوصية"
    subtitle="نلتزم بحماية خصوصية طلابنا وأولياء أمورهم. توضّح هذه السياسة البيانات التي نجمعها وكيفية استخدامها وحمايتها عند استخدام منصة أ/ مصطفى حسني."
    last-updated="14 يوليو 2026"
    counterpart="terms"
  >
    <template #icon>
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M9 12l2 2 4-4" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </template>

    <p class="legal-intro">
      تسري سياسة الخصوصية هذه على منصة <strong>أ/ مصطفى حسني - مدرس الكيمياء</strong>،
      المتاحة عبر الموقع الإلكتروني <a href="https://moustafahosney.com" target="_blank" rel="noopener">moustafahosney.com</a>
      وتطبيق الهاتف المحمول المرتبط بها (يُشار إليها مجتمعةً بـ«المنصة»). باستخدامك للمنصة فإنك
      توافق على الممارسات الموضّحة في هذه السياسة.
    </p>

    <h2>1. مقدمة</h2>
    <p>
      نحن ندرك أهمية خصوصية بياناتك، ونلتزم بحمايتها وفقًا للقوانين المعمول بها. الغرض من هذه
      المنصة تعليمي بحت؛ إذ توفّر للطلاب محتوى دراسيًا في مادة الكيمياء، وامتحانات، وواجبات،
      ومتابعة لمستواهم الدراسي. تشرح هذه الوثيقة نوع المعلومات التي نجمعها وأسباب جمعها وكيفية
      التعامل معها والحقوق المتاحة لك بشأنها.
    </p>

    <h2>2. المعلومات التي نجمعها</h2>
    <p>
      نجمع الحد الأدنى من البيانات اللازمة لتشغيل الخدمة التعليمية وتقديمها بالجودة المطلوبة،
      وتشمل الفئات التالية:
    </p>

    <h3>2.1 بيانات حساب الطالب</h3>
    <ul>
      <li>الاسم الكامل للطالب.</li>
      <li>رقم الهاتف الخاص بالطالب ورقم هاتف ولي الأمر.</li>
      <li>المرحلة والصف الدراسي والسنة الدراسية المختارة.</li>
      <li>النوع (ذكر / أنثى) لتنظيم المجموعات الدراسية المناسبة.</li>
      <li>رقم الحجز (Reservation ID) الذي يُستخدم كمعرّف لتسجيل الدخول.</li>
      <li>نتائج الامتحانات والواجبات وبيانات التقدّم الدراسي داخل المنصة.</li>
    </ul>

    <h3>2.2 معلومات الجهاز</h3>
    <p>
      عند استخدام المنصة قد نجمع تلقائيًا معلومات تقنية محدودة لأغراض التشغيل والأمان وتحسين
      الأداء، مثل: نوع الجهاز ونظام التشغيل، ونوع المتصفح، وإعدادات اللغة، وعنوان الـ IP بشكل
      مؤقت لأغراض الحماية ومنع إساءة الاستخدام. لا نستخدم هذه المعلومات لتحديد هويتك الشخصية
      خارج نطاق تشغيل الخدمة.
    </p>

    <h3>2.3 ملفات تعريف الارتباط والتخزين المحلي (Cookies / Local Storage)</h3>
    <p>
      نستخدم آلية <strong>التخزين المحلي (Local Storage)</strong> داخل متصفحك أو تطبيقك لحفظ
      بيانات الجلسة الأساسية، مثل رمز الدخول (Token) وبيانات المستخدم الأساسية وحالة المنصة،
      وذلك للحفاظ على تسجيل دخولك وتشغيل الخدمة بسلاسة. هذه البيانات تُخزَّن على جهازك أنت، ولا
      تُستخدم لأغراض تتبّع إعلاني. يمكنك حذفها في أي وقت عبر تسجيل الخروج أو مسح بيانات المتصفح/التطبيق.
    </p>

    <h2>3. كيفية استخدام المعلومات</h2>
    <p>نستخدم المعلومات التي نجمعها للأغراض التالية حصريًا:</p>
    <ul>
      <li>إنشاء حساب الطالب والتحقّق من هويته عند تسجيل الدخول.</li>
      <li>إتاحة الوصول إلى المحتوى الدراسي والامتحانات والواجبات المناسبة لصف الطالب.</li>
      <li>عرض النتائج ومتابعة المستوى الدراسي والتقدّم.</li>
      <li>تنظيم المجموعات الدراسية والتواصل مع الطالب أو ولي الأمر عند الحاجة.</li>
      <li>تحسين جودة الخدمة ومعالجة المشكلات التقنية وضمان أمان المنصة.</li>
    </ul>
    <p>
      نحن <strong>لا نبيع</strong> بياناتك الشخصية ولا نؤجّرها ولا نشاركها مع أطراف خارجية
      لأغراض تسويقية.
    </p>

    <h2>4. حماية البيانات</h2>
    <p>
      نتّخذ إجراءات تقنية وتنظيمية معقولة لحماية بياناتك من الوصول غير المصرّح به أو الفقدان أو
      التعديل، ومن ذلك تشفير الاتصال عبر بروتوكول <strong>HTTPS</strong>، وتقييد صلاحيات الوصول
      إلى البيانات على القائمين على المنصة فقط. ومع ذلك، لا توجد وسيلة نقل أو تخزين إلكتروني آمنة
      بنسبة 100%، ولذلك نبذل قصارى جهدنا للحماية دون أن نستطيع ضمان أمان مطلق.
    </p>

    <h2>5. خدمات الأطراف الثالثة</h2>
    <p>
      تعتمد المنصة على عدد محدود من خدمات الأطراف الثالثة اللازمة لتشغيلها، وتخضع بياناتك أثناء
      استخدام هذه الخدمات لسياسات الخصوصية الخاصة بها:
    </p>

    <h3>5.1 مقاطع الفيديو المضمّنة من YouTube</h3>
    <p>
      يُعرض جزء من المحتوى التعليمي عبر مقاطع فيديو مُضمّنة من <strong>YouTube</strong>. عند
      تشغيل هذه المقاطع قد تقوم Google بجمع بيانات وفق سياساتها الخاصة. نحرص حيثما أمكن على
      استخدام خيارات التضمين التي تحدّ من التتبّع، ويمكنك الاطلاع على
      <a href="https://policies.google.com/privacy" target="_blank" rel="noopener">سياسة خصوصية Google</a>
      لمعرفة كيفية تعاملها مع بياناتك.
    </p>

    <p class="legal-note">
      <strong>ملاحظة بشأن الإشعارات والتحليلات:</strong> لا تستخدم المنصة حاليًا أي خدمات
      إشعارات فورية (Push Notifications) أو أنظمة تحليلات خارجية لتتبّع سلوك المستخدمين
      (مثل Google Analytics). في حال إضافة أي من هذه الخدمات مستقبلًا، سيتم تحديث هذه السياسة
      وإخطار المستخدمين بذلك مسبقًا.
    </p>

    <h2>6. الاحتفاظ بالبيانات</h2>
    <p>
      نحتفظ ببيانات الطالب طوال مدة نشاط حسابه على المنصة وبالقدر اللازم لتقديم الخدمة التعليمية
      والوفاء بالالتزامات القانونية. عند التوقّف عن استخدام المنصة أو بناءً على طلب حذف الحساب،
      نحذف بياناتك الشخصية أو نجعلها مجهّلة الهوية خلال مدة زمنية معقولة، ما لم يكن الاحتفاظ بها
      مطلوبًا بموجب القانون.
    </p>

    <h2>7. خصوصية الأطفال</h2>
    <p>
      المنصة موجّهة لطلاب المرحلتين الإعدادية والثانوية، وقد يكون بعضهم دون السن القانونية الكاملة.
      لذلك يتم التسجيل واستخدام المنصة تحت إشراف ولي الأمر وبموافقته، ونطلب رقم هاتف ولي الأمر
      ضمن بيانات الحجز. نجمع من الطلاب القاصرين الحد الأدنى من البيانات اللازمة للخدمة التعليمية
      فقط. إذا كنت وليّ أمر وتعتقد أننا جمعنا بيانات طفلك دون موافقتك، يُرجى التواصل معنا لحذفها.
    </p>

    <h2>8. حقوق المستخدم</h2>
    <p>يحق لك، أنت أو ولي أمر الطالب، ممارسة الحقوق التالية بشأن بياناتك:</p>
    <ul>
      <li>الوصول إلى بياناتك الشخصية المسجّلة لدينا ومعرفة كيفية استخدامها.</li>
      <li>طلب تصحيح أي بيانات غير دقيقة أو تحديثها من خلال صفحة «تعديل البيانات».</li>
      <li>طلب حذف حسابك وبياناتك الشخصية.</li>
      <li>الاعتراض على معالجة معيّنة لبياناتك في الحدود التي يسمح بها القانون.</li>
    </ul>
    <p>لممارسة أي من هذه الحقوق، تواصل معنا عبر بيانات التواصل الموضّحة أدناه.</p>

    <h2>9. التعديلات على هذه السياسة</h2>
    <p>
      قد نقوم بتحديث سياسة الخصوصية من وقت لآخر لتعكس التغييرات في خدماتنا أو المتطلبات القانونية.
      سيظهر تاريخ «آخر تحديث» في أعلى الصفحة عند إجراء أي تعديل، ويُعد استمرارك في استخدام المنصة
      بعد التحديث موافقةً على السياسة المعدّلة.
    </p>

    <h2>10. التواصل معنا</h2>
    <div class="legal-contact">
      <p style="margin-bottom:.5rem">
        إذا كان لديك أي استفسار أو طلب يخصّ خصوصيتك أو بياناتك، يمكنك التواصل معنا عبر:
      </p>
      <ul style="margin-bottom:0">
        <li>البريد الإلكتروني: <a href="mailto:info@ahmedhawam.com">info@ahmedhawam.com</a></li>
        <li>واتساب: <a href="https://wa.me/201008430711" target="_blank" rel="noopener">+20 12 80194879</a></li>
        <li>الموقع الإلكتروني: <a href="https://moustafahosney.com" target="_blank" rel="noopener">moustafahosney.com</a></li>
      </ul>
    </div>
  </LegalDocument>
</template>

<script>
import LegalDocument from '@/components/common/LegalDocument.vue';
import { applySeoMeta } from '@/composables/useSeoMeta';

export default {
  name: 'PrivacyPolicyPage',
  components: { LegalDocument },
  mounted() {
    this._seoCleanup = applySeoMeta({
      title: 'سياسة الخصوصية | أ/ مصطفى حسني - مدرس الكيمياء',
      description:
        'سياسة الخصوصية لمنصة أ/ مصطفى حسني لتعليم الكيمياء: تعرّف على البيانات التي نجمعها من الطلاب وكيفية استخدامها وحمايتها وحقوقك بشأنها.',
      canonical: 'https://moustafahosney.com/privacy-policy',
      type: 'article',
    });
  },
  beforeUnmount() {
    if (this._seoCleanup) this._seoCleanup();
  },
};
</script>
